
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Star } from "lucide-react";

const StatisticsSection: React.FC = () => {
  return (
    <Card className="md:col-span-3">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Star className="h-5 w-5" />
          Estatísticas Profissionais
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid gap-4 md:grid-cols-4">
          <div className="text-center p-6 bg-muted rounded-lg">
            <div className="text-3xl font-bold text-primary">0</div>
            <div className="text-sm text-muted-foreground">Consultas Realizadas</div>
          </div>
          <div className="text-center p-6 bg-muted rounded-lg">
            <div className="text-3xl font-bold text-primary">0</div>
            <div className="text-sm text-muted-foreground">Pacientes Ativos</div>
          </div>
          <div className="text-center p-6 bg-muted rounded-lg">
            <div className="text-3xl font-bold text-primary">5.0</div>
            <div className="text-sm text-muted-foreground">Avaliação Média</div>
          </div>
          <div className="text-center p-6 bg-muted rounded-lg">
            <div className="text-3xl font-bold text-primary">0</div>
            <div className="text-sm text-muted-foreground">Avaliações</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default StatisticsSection;
